import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function UnregisteredList() {
  const [unregistered, setUnregistered] = useState([]);
  const [residents, setResidents] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedResidentId, setSelectedResidentId] = useState('');

  // 未登録者リストを取得
  const fetchUnregistered = async () => {
    try {
      const response = await fetch(`${API_URL}/api/unregistered`);
      const data = await response.json();
      if (data.success) setUnregistered(data.unregistered);
    } catch (error) {
      console.error('未登録者取得エラー:', error);
    }
  };

  // 住民リストを取得
  const fetchResidents = async () => {
    try {
      const response = await fetch(`${API_URL}/api/residents`);
      const data = await response.json();
      if (data.success) setResidents(data.residents);
    } catch (error) {
      console.error('住民取得エラー:', error);
    }
  };

  useEffect(() => {
    fetchUnregistered();
    fetchResidents();
  }, []);

  // 住民にLINE IDを紐付け
  const handleLink = async (unregisteredItem) => {
    if (!selectedResidentId) {
      alert('紐付ける住民を選択してください');
      return;
    }

    try {
      // 住民のLINE User IDを更新
      const resident = residents.find(r => r.id === parseInt(selectedResidentId));
      if (!resident) return;

      const response = await fetch(`${API_URL}/api/residents/${selectedResidentId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...resident,
          line_user_id: unregisteredItem.line_user_id
        })
      });

      const data = await response.json();

      if (data.success) {
        // 未登録者リストから削除
        await fetch(`${API_URL}/api/unregistered/${unregisteredItem.id}`, {
          method: 'DELETE'
        });

        alert(`${resident.name}さんにLINE IDを紐付けました！`);
        setSelectedResidentId('');
        fetchUnregistered();
        fetchResidents();
      }
    } catch (error) {
      console.error('紐付けエラー:', error);
      alert('紐付けに失敗しました');
    }
  };

  // 未登録者を削除
  const handleDelete = async (id) => {
    if (!window.confirm('この未登録者を削除しますか？')) return;

    try {
      await fetch(`${API_URL}/api/unregistered/${id}`, {
        method: 'DELETE'
      });
      fetchUnregistered();
    } catch (error) {
      console.error('削除エラー:', error);
    }
  };

  return (
    <div>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h2 style={{ margin: 0 }}>
          LINE未登録者リスト
          {unregistered.length > 0 && (
            <span style={{
              marginLeft: '10px',
              backgroundColor: '#f44336',
              color: 'white',
              borderRadius: '50%',
              padding: '2px 8px',
              fontSize: '14px'
            }}>
              {unregistered.length}
            </span>
          )}
        </h2>
        <button
          onClick={() => { fetchUnregistered(); fetchResidents(); }}
          style={{
            padding: '10px 20px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          更新
        </button>
      </div>

      {unregistered.length === 0 ? (
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '10px',
          textAlign: 'center',
          color: '#999'
        }}>
          未登録者はいません
        </div>
      ) : (
        <div>
          {unregistered.map((item) => (
            <div key={item.id} style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '10px',
              marginBottom: '15px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: '2px solid #FF9800'
            }}>
              <div style={{ marginBottom: '15px' }}>
                <p style={{ margin: '5px 0', fontWeight: 'bold' }}>
                  LINE User ID: {item.line_user_id}
                </p>
                <p style={{ margin: '5px 0', color: '#666', fontSize: '14px' }}>
                  友だち追加日時: {new Date(item.followed_at).toLocaleString('ja-JP')}
                </p>
              </div>

              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <select
                  value={selectedUserId === item.line_user_id ? selectedResidentId : ''}
                  onChange={(e) => {
                    setSelectedUserId(item.line_user_id);
                    setSelectedResidentId(e.target.value);
                  }}
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    fontSize: '16px'
                  }}
                >
                  <option value="">-- 住民を選択して紐付け --</option>
                  {residents
                    .filter(r => !r.line_user_id)
                    .map(r => (
                      <option key={r.id} value={r.id}>
                        {r.name}（{r.phone}）
                      </option>
                    ))
                  }
                </select>

                <button
                  onClick={() => handleLink(item)}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap'
                  }}
                >
                  紐付け
                </button>

                <button
                  onClick={() => handleDelete(item.id)}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  削除
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UnregisteredList;
